/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderReceiveAddressVo
 */
export interface OrderReceiveAddressVo {
    /**
     * 收件人姓名（韩文）
     * @type {string}
     * @memberof OrderReceiveAddressVo
     */
    nameKr?: string;
    /**
     * 收件人姓名（英文）
     * @type {string}
     * @memberof OrderReceiveAddressVo
     */
    nameEn?: string;
    /**
     * 收件人邮编
     * @type {string}
     * @memberof OrderReceiveAddressVo
     */
    zip?: string;
    /**
     * 收件人地址
     * @type {string}
     * @memberof OrderReceiveAddressVo
     */
    address?: string;
    /**
     * 收件人详细地址
     * @type {string}
     * @memberof OrderReceiveAddressVo
     */
    addressDetail?: string;
    /**
     * 收件人电话
     * @type {string}
     * @memberof OrderReceiveAddressVo
     */
    mobileNo?: string;
    /**
     * 个人还是企业 1 企业, 2 个人
     * @type {number}
     * @memberof OrderReceiveAddressVo
     */
    ctmsType?: number;
    /**
     * 个人或企业清关号
     * @type {string}
     * @memberof OrderReceiveAddressVo
     */
    ctmsNo?: string;
    /**
     * 企业营业执照地址
     * @type {string}
     * @memberof OrderReceiveAddressVo
     */
    businessLicenseAddress?: string;
    /**
     * 配送要求(中文)
     * @type {string}
     * @memberof OrderReceiveAddressVo
     */
    receiverDeliveryRequirement?: string;
    /**
     * 预计收货日期
     * @type {string}
     * @memberof OrderReceiveAddressVo
     */
    arrivedTime?: string;
    /**
     * 营业执照文件
     * @type {string}
     * @memberof OrderReceiveAddressVo
     */
    businessLicenseFile?: string;
    /**
     * 配送要求（韩文）
     * @type {string}
     * @memberof OrderReceiveAddressVo
     */
    receiverDeliveryRequirementKr?: string;
    /**
     * 公司id
     * @type {number}
     * @memberof OrderReceiveAddressVo
     */
    companyId?: number;
    /**
     * 营业执照号
     * @type {string}
     * @memberof OrderReceiveAddressVo
     */
    businessLicenseNumber?: string;
}

/**
 * Check if a given object implements the OrderReceiveAddressVo interface.
 */
export function instanceOfOrderReceiveAddressVo(value: object): value is OrderReceiveAddressVo {
    return true;
}

export function OrderReceiveAddressVoFromJSON(json: any): OrderReceiveAddressVo {
    return OrderReceiveAddressVoFromJSONTyped(json, false);
}

export function OrderReceiveAddressVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderReceiveAddressVo {
    if (json == null) {
        return json;
    }
    return {
        
        'nameKr': json['nameKr'] == null ? undefined : json['nameKr'],
        'nameEn': json['nameEn'] == null ? undefined : json['nameEn'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'address': json['address'] == null ? undefined : json['address'],
        'addressDetail': json['addressDetail'] == null ? undefined : json['addressDetail'],
        'mobileNo': json['mobileNo'] == null ? undefined : json['mobileNo'],
        'ctmsType': json['ctmsType'] == null ? undefined : json['ctmsType'],
        'ctmsNo': json['ctmsNo'] == null ? undefined : json['ctmsNo'],
        'businessLicenseAddress': json['businessLicenseAddress'] == null ? undefined : json['businessLicenseAddress'],
        'receiverDeliveryRequirement': json['receiverDeliveryRequirement'] == null ? undefined : json['receiverDeliveryRequirement'],
        'arrivedTime': json['arrivedTime'] == null ? undefined : json['arrivedTime'],
        'businessLicenseFile': json['businessLicenseFile'] == null ? undefined : json['businessLicenseFile'],
        'receiverDeliveryRequirementKr': json['receiverDeliveryRequirementKr'] == null ? undefined : json['receiverDeliveryRequirementKr'],
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'businessLicenseNumber': json['businessLicenseNumber'] == null ? undefined : json['businessLicenseNumber'],
    };
}

export function OrderReceiveAddressVoToJSON(json: any): OrderReceiveAddressVo {
    return OrderReceiveAddressVoToJSONTyped(json, false);
}

export function OrderReceiveAddressVoToJSONTyped(value?: OrderReceiveAddressVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nameKr': value['nameKr'],
        'nameEn': value['nameEn'],
        'zip': value['zip'],
        'address': value['address'],
        'addressDetail': value['addressDetail'],
        'mobileNo': value['mobileNo'],
        'ctmsType': value['ctmsType'],
        'ctmsNo': value['ctmsNo'],
        'businessLicenseAddress': value['businessLicenseAddress'],
        'receiverDeliveryRequirement': value['receiverDeliveryRequirement'],
        'arrivedTime': value['arrivedTime'],
        'businessLicenseFile': value['businessLicenseFile'],
        'receiverDeliveryRequirementKr': value['receiverDeliveryRequirementKr'],
        'companyId': value['companyId'],
        'businessLicenseNumber': value['businessLicenseNumber'],
    };
}

